import { useMutation } from "@tanstack/react-query";
import { postHprAadhaarResendOtp } from "apis";

const usePostHprResendAadhaarOtp = () => {
  return useMutation(postHprAadhaarResendOtp);
};

export default usePostHprResendAadhaarOtp;
